export default "__VITE_ASSET__Bw74Vfqf__"